import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'
import { Avatar } from '../components/Avatar.tsx'

export interface GuestCountBarProps {
  goingCount: number
  cantGoCount: number
  avatars: Array<{ name: string; src?: string }>
  blurred: boolean
  className?: string
}

export const GuestCountBar = forwardRef<HTMLDivElement, GuestCountBarProps>(
  ({ goingCount, cantGoCount, avatars, blurred, className }, ref) => {
    const visibleAvatars = avatars.slice(0, 3)
    const overflowCount = avatars.length - 3

    return (
      <div ref={ref} className={cn('guest-count-bar', className)}>
        {avatars.length > 0 && (
          <div className="guest-count-avatars">
            {visibleAvatars.map((avatar, i) => (
              <Avatar
                key={i}
                name={avatar.name}
                src={avatar.src}
                size="sm"
                blurred={blurred}
                borderColor="#ffffff"
                borderWidth={2}
                className="guest-count-avatar"
              />
            ))}
            {overflowCount > 0 && (
              <div className="guest-count-overflow">+{overflowCount}</div>
            )}
          </div>
        )}
        <span className="guest-count-text">
          {goingCount} going &middot; {cantGoCount} can&apos;t go
        </span>
      </div>
    )
  },
)

GuestCountBar.displayName = 'GuestCountBar'
